export interface WhoAmIItem {
    name: string;
    category: string;
    custom?: boolean;
}

export const CUSTOM_CATEGORY = 'Свои';

export const BASE_NAMES: WhoAmIItem[] = [
    // Знаменитости
    {name: 'Илон Маск', category: 'Знаменитости'},
    {name: 'Альберт Эйнштейн', category: 'Знаменитости'},
    {name: 'Леонардо Ди Каприо', category: 'Знаменитости'},
    {name: 'Криштиану Роналду', category: 'Знаменитости'},
    {name: 'Тейлор Свифт', category: 'Знаменитости'},
    {name: 'Стив Джобс', category: 'Знаменитости'},
    {name: 'Уилл Смит', category: 'Знаменитости'},
    {name: 'Опра Уинфри', category: 'Знаменитости'},
    {name: 'Билли Айлиш', category: 'Знаменитости'},
    {name: 'Джеки Чан', category: 'Знаменитости'},

    // Персонажи фильмов и сериалов
    {name: 'Гарри Поттер', category: 'Персонажи фильмов'},
    {name: 'Дарт Вейдер', category: 'Персонажи фильмов'},
    {name: 'Шерлок Холмс', category: 'Персонажи фильмов'},
    {name: 'Джек Воробей', category: 'Персонажи фильмов'},
    {name: 'Форрест Гамп', category: 'Персонажи фильмов'},
    {name: 'Джокер', category: 'Персонажи фильмов'},
    {name: 'Люк Скайуокер', category: 'Персонажи фильмов'},
    {name: 'Гэндальф', category: 'Персонажи фильмов'},
    {name: 'Терминатор', category: 'Персонажи фильмов'},
    {name: 'Нео', category: 'Персонажи фильмов'},

    // Мультики и сказки
    {name: 'Микки Маус', category: 'Мультики и сказки'},
    {name: 'Чебурашка', category: 'Мультики и сказки'},
    {name: 'Баба Яга', category: 'Мультики и сказки'},
    {name: 'Кощей Бессмертный', category: 'Мультики и сказки'},
    {name: 'Винни-Пух', category: 'Мультики и сказки'},
    {name: 'Шрек', category: 'Мультики и сказки'},
    {name: 'Губка Боб', category: 'Мультики и сказки'},
    {name: 'Русалочка', category: 'Мультики и сказки'},
    {name: 'Золушка', category: 'Мультики и сказки'},
    {name: 'Колобок', category: 'Мультики и сказки'},

    // Супергерои и злодеи
    {name: 'Бэтмен', category: 'Супергерои и злодеи'},
    {name: 'Человек-паук', category: 'Супергерои и злодеи'},
    {name: 'Супермен', category: 'Супергерои и злодеи'},
    {name: 'Тор', category: 'Супергерои и злодеи'},
    {name: 'Железный человек', category: 'Супергерои и злодеи'},
    {name: 'Женщина-кошка', category: 'Супергерои и злодеи'},
    {name: 'Халк', category: 'Супергерои и злодеи'},
    {name: 'Дэдпул', category: 'Супергерои и злодеи'},
    {name: 'Чудо-женщина', category: 'Супергерои и злодеи'},
    {name: 'Танос', category: 'Супергерои и злодеи'},

    // Исторические личности
    {name: 'Наполеон Бонапарт', category: 'Исторические личности'},
    {name: 'Пётр Первый', category: 'Исторические личности'},
    {name: 'Клеопатра', category: 'Исторические личности'},
    {name: 'Христофор Колумб', category: 'Исторические личности'},
    {name: 'Леонардо да Винчи', category: 'Исторические личности'},
    {name: 'Уильям Шекспир', category: 'Исторические личности'},
    {name: 'Александр Македонский', category: 'Исторические личности'},
    {name: 'Моцарт', category: 'Исторические личности'},
    {name: 'Чарльз Дарвин', category: 'Исторические личности'},
    {name: 'Мария Кюри', category: 'Исторические личности'},
];
